import React, { FC } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { CHANGE_LOG_EDIT_URL, CHANGE_LOG_HISTORY_URL, CHANGE_LOG_MANAGE_URL, CHANGE_LOG_NEW_URL } from 'constants/routes'
import { usePermission } from 'hooks/usePermission'
import { CHANGE_LOG_MANAGE_PERM } from 'constants/permissions'
import WhatsNewHistory from 'pages/WhatsNewHistory'
import ChangeLogManage from 'pages/ChangeLogManage'
import ChangeLogCreate from 'pages/ChangeLogCreate'
import ChangeLogEdit from 'pages/ChangeLogEdit'

const ChangeLogContainer: FC = () => {
  const { hasPermission } = usePermission()
  const canManage = hasPermission(CHANGE_LOG_MANAGE_PERM)

  return (
    <Switch>
      <Route path={CHANGE_LOG_HISTORY_URL} exact component={WhatsNewHistory} />
      {canManage && <Route path={CHANGE_LOG_NEW_URL} exact component={ChangeLogCreate} />}
      {canManage && <Route path={CHANGE_LOG_EDIT_URL} exact component={ChangeLogEdit} />}
      {canManage && <Route path={CHANGE_LOG_MANAGE_URL} exact component={ChangeLogManage} />}
      <Redirect to={CHANGE_LOG_HISTORY_URL} />
    </Switch>
  )
}

export default ChangeLogContainer
